import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { ChosenPluginsComponent } from '../../../../components/chosen-plugins/chosen-plugins.component';
import { ChangeDptService } from '../../../../services/entity-base/entity-service/ownerRoleManage/change-department.service';
import { OrganizationDptAdminService } from '../../../../services/entity-base/entity-service/ownerRoleManage/organization-dpt-admin.service';
import { OrganizationForAdminService } from '../../../../services/entity-base/entity-service/ownerRoleManage/organization-for-admin.service';
import { LoadingService } from '../../../../services/loading/loading.service';
import { UserInfoService } from '../../../../services/user-info/user-info.service';

@Component({
  selector: 'bw-index-top',
  templateUrl: './index-top.component.html',
  styleUrls: ['./index-top.component.scss']
})
export class IndexTopComponent implements OnInit, OnDestroy {
  @ViewChild('orgListRef') orgListRef: ChosenPluginsComponent;
  @ViewChild('dptListRef') dptListRef: ChosenPluginsComponent;
  subscriptionArr: Subscription[] = [];
  orgListOpt: any = {
    valueObj: {
      chosenValue: -1,
    },
    chosenItem: {
      isMultiple: false,
      is_chosen_rtl: false,
      isNO: false,
      chosenOption: []
    }
  };

  dptListOpt: any = {
    valueObj: {
      chosenValue: -1,
    },
    chosenItem: {
      isMultiple: false,
      is_chosen_rtl: false,
      isNO: false,
      chosenOption: []
    }
  };

  dptId = -1;
  obj: any = {
    organizationName: '-',
    dptName: '-'
  };

  userInfoData: any;

  constructor(private userInfo: UserInfoService,
    private router: Router,
    private loadingService: LoadingService,
    private orgForAdminService: OrganizationForAdminService,
    private orgDptAdminService: OrganizationDptAdminService,
    private changeDptService: ChangeDptService,
    private elementRef: ElementRef) { }

  ngOnInit() {
    const userInfo = JSON.parse(localStorage['userInfo']);
    this.userInfoData = userInfo;
    this.obj.organizationName = userInfo.adminInfo.organizationName || '-';
    this.obj.dptName = userInfo.adminInfo.departmentName || '-';
  }

  showModal() {
    $('#topModal').modal('show');
    this.loadingService.show();
    this.dptId = -1;
    this.dptListOpt.valueObj.chosenValue = -1;
    this.dptListRef.plugins.trigger('chosen:updated');
    this.orgListOpt.chosenItem.chosenOption = [];
    const sub: Subscription = this.orgForAdminService.getList()
      .subscribe(
        (res: any) => {
          this.loadingService.hide();
          res.data.organization.forEach(item => {
            this.orgListOpt.chosenItem.chosenOption.push({
              value: item.organizationId,
              name: item.organizationName
            });
          });
          setTimeout(() => {
            this.elementRef.nativeElement.querySelectorAll('.chosen-container').forEach(item => {
              item.style.width = '100%';
              $(item).trigger('liszt:updated');
            });
            this.orgListRef.plugins.trigger('chosen:updated');
          });
        },
        (err: any) => {
          this.loadingService.hide();
          $('#topModal').modal('hide');
          swal('获取用户所在机构列表失败', err.result.displaymsg, 'warning');
        }
      );
    this.subscriptionArr.push(sub);
  }

  onChosenOrg(e) {
    if (!(e === '' || parseInt(e, 0) === -1)) {
      const orgId = parseInt(e, 0);
      this.loadingService.show();
      this.dptListOpt.chosenItem.chosenOption = [];
      localStorage.setItem('organizationId', orgId.toString())
      const sub: Subscription = this.orgDptAdminService.getList({}, true, {
        organizationId: orgId
      })
        .subscribe(
          (res: any) => {
            this.loadingService.hide();
            res.data.department.forEach(item => {
              this.dptListOpt.chosenItem.chosenOption.push({
                value: item.departmentId,
                name: item.departmentName
              });
            });
            setTimeout(() => {
              this.elementRef.nativeElement.querySelectorAll('.chosen-container').forEach(item => {
                item.style.width = '100%';
                $(item).trigger('liszt:updated');
              });
              this.dptListRef.plugins.trigger('chosen:updated');
            });
          },
          (err: any) => {
            this.loadingService.hide();
            swal('获取科室列表失败', err.result.displaymsg, 'warning');
          }
        );
      this.subscriptionArr.push(sub);
    }
  }

  onChosenDpt(e) {
    if (!(e === '' || parseInt(e, 0) === -1)) {
      this.dptId = parseInt(e, 0);
      localStorage.setItem('departmentId', this.dptId.toString())
    } else {
      this.dptId = -1;
    }
  }

  saveChosen() {
    this.loadingService.show();
    $('#topModal').modal('hide');
    const sub: Subscription = this.changeDptService.post({
      departmentId: this.dptId
    })
      .subscribe(
        (res: any) => {
          this.loadingService.hide();
          swal('切换科室成功', '', 'success');
          localStorage['userInfo'] = '';
          const admin = res.data.admin;
          this.userInfo.save(Object.assign(admin, { token: localStorage.getItem('token') }), 'admin');
          this.router.navigate(['/admin/resource/mainpage']);
          window.location.reload();
        },
        (err: any) => {
          this.loadingService.hide();
          swal('切换科室失败', err.result.displaymsg, 'warning');
        }
      );
    this.subscriptionArr.push(sub);
  }

  onSignOut() {
    location.href = this.userInfo.userInfo.authority + '/login';
    // this.router.navigate([this.userInfo.userInfo.authority+'/login']);
    localStorage.clear();
  }

  onUpdatePassword() {
    this.router.navigate([this.userInfo.userInfo.authority + '/reset-password']);
    localStorage.clear();
  }

  ngOnDestroy() {
    for (const sub of this.subscriptionArr) {
      try {
        sub.unsubscribe();
      } catch (e) { }
    }
  }
}



// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index/index-top/index-top.component.ts